import CollapsibleFieldTemplate from './CollapsibleFieldTemplate';
import PdfMarginField from './PdfMarginField';
import ThemeColorPickerField from './ThemeColorPickerField';

const Fields: any = {
    PdfMarginField,
    ThemeColorPickerField,
    CollapsibleFieldTemplate: CollapsibleFieldTemplate,
};

export default Fields;
